
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M78.3 284.8c-5.5 0-10 4.5-10 10v.9c0 5.5 4.5 10 10 10s10-4.5 10-10v-.9c0-5.5-4.4-10-10-10zm0 30.3c-5.5 0-10 4.5-10 10v70c0 5.5 4.5 10 10 10s10-4.5 10-10v-70c0-5.5-4.4-10-10-10zm355.4-30.3c-5.5 0-10 4.5-10 10v.9c0 5.5 4.5 10 10 10s10-4.5 10-10v-.9c0-5.5-4.5-10-10-10zm0 30.3c-5.5 0-10 4.5-10 10v70c0 5.5 4.5 10 10 10s10-4.5 10-10v-70c0-5.5-4.5-10-10-10z"}}),_c('path',{attrs:{"d":"M455 248.1v-28h1c5.5 0 10-4.5 10-10C466 94.2 371.8 0 256 0S46 94.2 46 210c0 5.5 4.5 10 10 10h1v28c-34 19-57 55.3-57 97 0 46.2 28.4 85.9 68.7 102.6 2.7 21.6 21.2 38.4 43.6 38.4h108.4c4.7 15 18.8 26 35.3 26 20.4 0 37-16.6 37-37s-16.6-37-37-37c-17.3 0-31.9 11.9-35.9 28H112.3c-8.7 0-16.4-4.7-20.5-11.7 6.3 1.1 12.7 1.7 19.3 1.7h3c5.5 0 10-4.5 10-10V244c0-2.7-1.1-5.2-2.9-7.1-1.9-1.9-4.4-2.9-7.1-2.9h-5v-14h11.1c5.5 0 10-4.5 10-10 0-69.4 56.5-125.9 125.9-125.9S381.9 140.6 381.9 210c0 5.5 4.5 10 10 10H403v14h-5c-2.7 0-5.2 1.1-7.1 2.9-1.9 1.9-2.9 4.4-2.9 7.1v202c0 5.5 4.5 10 10 10h3c61.2 0 111-49.8 111-111 0-41.6-23-78-57-96.9zM256 458c9.4 0 17 7.6 17 17s-7.6 17-17 17-17-7.6-17-17 7.6-17 17-17zm-152-22.3c-46.9-3.6-84-42.9-84-90.7 0-47.8 37.1-87.1 84-90.7v181.4zM77 238.6V220h12v16l-12 2.6zM401.6 200C396.4 124.2 333.1 64.1 256 64.1S115.6 124.2 110.4 200H66.3C71.5 99.9 154.6 20 256 20s184.5 79.9 189.7 180h-44.1zm33.4 20v19.3c-3.9-1.3-7.9-2.3-12-3.1V220h12zm-27 215.7V254.2c46.9 3.6 84 42.9 84 90.7s-37.1 87.2-84 90.8z"}})])
          )
        }
      }
    